module.exports = __webpack_public_path__ + "img/plant-kitchen-pc.1c81cb61.png";